import * as React from "react";
import { Route } from "@core-ui/interfaces/Router";

export interface RouteContextValue<T extends string> {
    navigateTo: <P = {}>(name: T, data?: P, replace?: boolean, errorCallback?: VoidFunction) => void;
    goBack: () => void;
    canGoBack: (numberOfPagesToGoBack?: number) => boolean;
    route?: Route<T>;
    isForward: boolean;
}

export const RouteContext = React.createContext<RouteContextValue<string>>({
    navigateTo: () => void 0,
    canGoBack: () => false,
    goBack: () => void 0,
    isForward: true,
});

if (__DEV__) {
    RouteContext.displayName = "RouteContext";
}
